import { useActiveSurgeryInfo } from '@/modules/surgicalEvent/surgicalEvent.slice';
import { Risk } from '@/modules/surgicalEvent/surgicalEvent.model';
import { useCurrentHospital } from '@/modules/hospital';

export const useActiveSurgerySeverityToRisk = (): Risk | undefined => {
  const severity = useActiveSurgeryInfo().currentData?.surgeryRisk;

  if (!severity || severity === 'NOT_APPLICABLE') {
    return undefined;
  }

  if (severity === 'VERY_HIGH') {
    return 'HIGH';
  }

  if (severity === 'VERY_LOW') {
    return 'LOW';
  }

  return severity;
};

/** Whether the patient's hospital plans follow-up surgeries; without it no plan is fetched or shown. */
export const useIsFollowUpPlanEnabledOnHospital = () => {
  const {
    queryResult: { data: hospital }
  } = useCurrentHospital();
  return !!hospital?.followUpPlanModuleEnabled;
};
